import * as React from "react";
import Modal from "../../ui/modal/Modal";
import "./quoteDetailsModal.scss"
import {none, Option, some} from "ts-option";
import QuoteDetails from "../../../model/quote/QuoteDetails";
import AttachmentApi from "../../../api/AttachmentApi";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import IconSmall from "../../../hiberUiKit/src/atoms/Icon/IconSmall";
import Loading from "../../ui/loading/Loading";
import Amount from "../../../model/common/Amount";
import * as _ from "underscore";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {connect, Dispatch} from "react-redux";
import {RootState} from "../../../store/reducer/root/RootState";
import {fetchQuoteDetails} from "../../../store/action/quote/quote";
import {getQuoteDetails} from "../../../store/view/quote";
import Toast from "../../helper/Toast";
import {api} from "../../../api/api";

interface ComponentProps {
	/**
	 * On close callback
	 */
	onClose: () => void
	/**
	 * Quote Id, needed to get quote details.
	 */
	quoteId: string,
	/**
	 * Accept quote action.
	 * @param {string} leadId
	 * @param {string} quoteId
	 */
	onReviewQuoteClick: () => void;
	/**
	 * Quote version number
	 */
	versionNumber?: number
}

interface IState {
	/**
	 * If true, there was an attempt to fetch quote details data.
	 */
	quoteDetailsFetched: boolean
	/**
	 * Quote details.
	 */
	quoteDetails: Option<QuoteDetails>;
}

interface ReduxProps {
	/**
	 * Quote details.
	 */
	quoteDetails: Option<QuoteDetails>;
}

interface DispatchProps {
	/**
	 * Fetch quote details action.
	 */
	fetchQuoteDetails: (quoteId: string) => void;
}

type Props = ComponentProps & ReduxProps & DispatchProps;

class QuoteDetailsModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {quoteDetailsFetched: false, quoteDetails: none};
		this.checkQuoteDetailsExists = this.checkQuoteDetailsExists.bind(this);
	}

	componentDidMount(): void {
		this.checkQuoteDetailsExists();
	}

	componentWillReceiveProps(nextProps: Readonly<Props>): void {
		if (this.props.quoteId !== nextProps.quoteId) {
			this.checkQuoteDetailsExists(nextProps);
		}
	}

	render() {
		const {quoteDetails} = this.props.versionNumber ? this.state : this.props;
		let quoteRefNumber = quoteDetails.map(
			q => `Quote - ${q.referenceNumber.getOrElse("")}${q.versionNumber > 1 ? ` v${q.versionNumber}` : ""}`).getOrElse("");
		const attachments = quoteDetails.map(q => q.attachments).getOrElse([]);
		const totalPrice = quoteDetails.map(q => q.totalPrice.format()).getOrElse("");
		const partsPrice = quoteDetails.map(q => q.getPartsPrice()).getOrElse(Amount.fromPounds(0)).format()
		const margin = quoteDetails.map(q => q.markupAmount.format()).getOrElse("");
		const installerEarnings = quoteDetails.map(q => q.getInstallerGross()).map(a => a.format()).getOrElse("");
		const hiberCommision = quoteDetails.map(q => q.getHiberCommision()).map(c => c.format()).getOrElse("");
		return (
			<Modal onCloseClicked={this.props.onClose} title={quoteRefNumber} mediumWidth>
				<Loading isLoading={quoteDetails.isEmpty}>
					<div className="c-quote-details-modal">
						{attachments.map((a, index) => {
							return (
								<span key={index}>
									<a
										href={AttachmentApi.getAttachmentDownloadUrl(a.id)}
										target="_blank" className={"t-link"} data-name={"download"}>{a.name}
									</a>
									{a.description.map(d =>
										<React.Fragment>&nbsp;<IconSmall icon={Icon.Note}/></React.Fragment>
									).orNull}
								</span>
							)
						})}
						<br/>
						<span>Total price: {totalPrice}</span>
						<span>Parts price: {partsPrice}</span>
						<span>Margin: {margin}</span>
						<span>Installer earnings (ex. VAT): {installerEarnings}</span>
						<span>hiber earnings (ex. VAT): {hiberCommision}</span>
						{quoteDetails.flatMap(qd => qd.rewardPoints).map(
							rewardPoints => <span>Rewards points: {rewardPoints}</span>).orNull}
						<div className="c-quote-details-modal_review-quote-button">
							<ButtonPrimary label="Review quote" onClick={this.props.onReviewQuoteClick}/>
						</div>
					</div>
				</Loading>
			</Modal>
		);
	}

	/**
	 * Check if quote details exists.
	 * @param props
	 */
	checkQuoteDetailsExists(props: Props = this.props) {
		if (props.versionNumber) {
			api.instance.quoteApi.fetchQuoteDetails(props.quoteId, props.versionNumber)
				.then(qd => this.setState({quoteDetails: some(qd)}))
				.catch((error) => notifyBugsnagAndShowToast(error, "Fetch quote details"))
		}
		else {
			if (props.quoteDetails.isEmpty) {
				if (this.state.quoteDetailsFetched) {
					Toast.error("Cannot fetch quote data", "Fetch quote details");
					props.onClose();
				}
				else {
					props.fetchQuoteDetails(props.quoteId);
					this.setState({quoteDetailsFetched: true});
				}
			}
		}
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	return {
		quoteDetails: getQuoteDetails(props.quoteId, state)
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchQuoteDetails: (quoteId: string) => dispatch(
			fetchQuoteDetails(quoteId, () => {}, (error) => {notifyBugsnagAndShowToast(error, "Fetch quote details")})
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(QuoteDetailsModal)